/* eslint-disable react/no-multi-comp */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Member } from 'react-wot-bootstrap'
import DefaultTooltip from 'components/DefaultTooltip/DefaultTooltip'
import Vehicle from './components/Vehicle/Vehicle'


import {
    FREE_SLOT_CAPTION,
    LOCKED_SLOT_CAPTION,
    TOOLTIPS,
} from './constants'

import styles from './Squad.scss'

export const DisabledSlot = () => {
    const className = classNames(styles.tr, styles.tr__disabled)

    return (
        <div className={className}>
            <div className={styles.td}/>
        </div>
    )
}

export const FreeSlot = ({ index }) => {
    const className = classNames(styles.tr, styles.tr__free)
    const tdClassName = classNames(styles.td, styles.td__nickname)

    return (
        <div className={className}>
            <div className={tdClassName}>
                <span className={styles.numeration}>
                    {index}
                </span>
                <span className={styles.name}>
                    {FREE_SLOT_CAPTION}
                </span>
            </div>
        </div>
    )
}
FreeSlot.propTypes = {
    index: PropTypes.number.isRequired,
}

export const LegionarySlot = () => {
    const className = classNames(styles.tr, styles.tr__lockedSlot)
    const tdClassName = classNames(styles.td, styles.td__nickname)

    return (
        <div className={className}>
            <div className={tdClassName}>
                <span
                    className={styles.lockedSlotIcon}
                    data-tip data-for={TOOLTIPS.LEGIONARY.id}
                />
                <span className={styles.name}>
                    {LOCKED_SLOT_CAPTION}
                </span>
            </div>
        </div>
    )
}

export const MemberSlot = ({ member, index, realm, isLegionary }) => {
    const nicknameTDClassName = classNames(styles.td, styles.td__nickname)
    const ratingTDClassName = classNames(styles.td, styles.td__rating)
    const vehicleTDClassName = classNames(styles.td, styles.td__vehicle)

    const {
        account_nickname: name,
    } = member

    let listCounter
    if (member.is_commander) {
        listCounter = (
            <span
                className={styles.commanderIcon}
                data-tip data-for={TOOLTIPS.COMMANDER.id}
            >
                <DefaultTooltip {...TOOLTIPS.COMMANDER} />
            </span>
        )
    } else if (isLegionary) {
        listCounter = (
            <span
                className={styles.lockedSlotIcon}
                data-tip data-for={TOOLTIPS.LEGIONARY.id}
            />
        )
    } else {
        listCounter = (
            <span className={styles.numeration}>{`${index}.`}</span>
        )
    }

    return (
        <div className={styles.tr}>
            <div className={nicknameTDClassName}>
                {listCounter}
                <span className={styles.name}>
                    <Member
                        name={name}
                        clanTag={member.clan_tag}
                        clanColor='#c9c9b6'
                        tooltipId={`${TOOLTIPS.PARTICIPANT.id}.${name}`}
                    />
                    <DefaultTooltip
                        id={`${TOOLTIPS.PARTICIPANT.id}.${name}`}
                        message={member.clan_tag ? `${name}[${member.clan_tag}]` : name}
                    />
                </span>
            </div>

            <div className={ratingTDClassName}>
                <span className={styles.rating}>{member.account_rating}</span>
            </div>

            <div className={vehicleTDClassName}>
                <Vehicle vehicle={member.vehicle} realm={realm} />
            </div>
        </div>
    )
}
MemberSlot.propTypes = {
    index: PropTypes.number.isRequired,
    realm: PropTypes.string.isRequired,
    member: PropTypes.shape({
        account_nickname: PropTypes.string.isRequired,
        account_rating: PropTypes.number.isRequired,
        is_commander: PropTypes.bool,
        clan_tag: PropTypes.string,
        vehicle: PropTypes.string,
    }).isRequired,
    isLegionary: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/Squad/slots.jsx